import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Box,
} from "@mui/material";
import deleteicon from "../../assets/images/svg/delete-icon.svg";
import { useState } from "react";
import { $crud } from "../../utils/CrudFactory";
import uploadicon from "../../assets/images/svg/download.svg";
import { formatter } from "../../helper/functions";

const PaySelectedModal = ({
  open,
  onClose,
  onSubmit,
  selectedRows,
  recipientId,
  recipientType,
  refreshData,
  userId,
  setEvidencePreview,
}) => {
  const [notes, setNotes] = useState("");
  const [payoutMethod, setPayoutMethod] = useState("");
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      const formData = new FormData();
      formData.append("recipientId", recipientId);
      formData.append("recipientType", recipientType);
      formData.append("method", payoutMethod);
      formData.append("notes", notes);
      formData.append("file", file);
      formData.append(
        "selectedOrderIds",
        JSON.stringify(selectedRows.map((row) => row.orderId))
      );
      formData.append(
        "selectedPaymentIds",
        JSON.stringify(selectedRows.map((row) => row._id))
      );

      const { data } = await $crud.createForm("admin/create-payout", formData);

      onSubmit({
        ...data,
        selectedRows,
        payoutMethod: payoutMethod,
        notes: notes,
        evidenceUrl: data.evidenceUrl || "", // If not returned, fallback
        totalAmount: selectedRows.reduce(
          (sum, row) => sum + (Number(row.amount) || 0),
          0
        ),
      });

      refreshData();
      onClose();
    } catch (err) {
      console.error("Payout submission failed:", err);
    } finally {
      setSubmitting(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    if (selectedFile) {
      setPreviewUrl(URL.createObjectURL(selectedFile));
      // setEvidencePreview(URL.createObjectURL(selectedFile));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      sx={{
        "& .MuiDialog-paper": {
          padding: 3,
          background: "#ffffff",
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          color: "#673C8E",
          fontSize: 22,
          fontWeight: 700,
        }}
      >
        Paying Pending Payment
      </DialogTitle>

      <Typography
        sx={{
          textAlign: "center",
          fontSize: 16,
          fontWeight: 600,
          color: "#673C8E",
          marginBottom: 2,
        }}
      >
        Paying {selectedRows.length}{" "}
        {selectedRows.length > 1 ? "Entries" : "Entry"} To {recipientId} -
        Amount{" "}
        {formatter.format(
          selectedRows.reduce((obj, curr) => obj + curr.amount, 0)
        )}{" "}
        CAD
      </Typography>

      <DialogContent>
        <Box sx={{ marginBottom: 2 }}>
          <Typography
            sx={{ fontSize: "14px", fontWeight: 600, marginBottom: 1 }}
          >
            Payout Method
          </Typography>
          <TextField
            placeholder="Cheque"
            fullWidth
            value={payoutMethod}
            onChange={(e) => setPayoutMethod(e.target.value)}
          />
        </Box>
        <Box sx={{ marginBottom: 2 }}>
          <Typography
            sx={{ fontSize: "14px", fontWeight: 600, marginBottom: 1 }}
          >
            Notes
          </Typography>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            style={{
              marginBottom: "20px",
              width: "100%",
              height: "105px",
              padding: "10px",
              outline: "none",
              color: "black",
              resize: "none",
              border: "1px solid #683C8C",
              borderRadius: "4px",
            }}
          />
        </Box>
        <Box sx={{ marginBottom: 2 }}>
          <Typography
            sx={{ fontSize: "14px", fontWeight: 600, marginBottom: 1 }}
          >
            Evidence (Optional) - Upload Image (1050 X 495) PX
          </Typography>
          {file ? (
            <Box display={"flex"} alignItems={"center"} gap="5px">
              <img
                src={URL.createObjectURL(file)}
                alt="preview-img"
                style={{
                  width: "200px",
                  height: "200px",
                  objectFit: "contain",
                }}
              />
              <Button onClick={() => setFile(null)}>
                <img src={deleteicon} alt="delete" />
              </Button>
            </Box>
          ) : (
            <Box
              sx={{
                border: "2px dashed #673C8E",
                padding: 2,
                paddingY: "50px",
                textAlign: "center",
                cursor: "pointer",
              }}
              onClick={() => document.getElementById("fileUpload").click()}
            >
              <input
                id="fileUpload"
                type="file"
                hidden
                onChange={handleFileChange}
              />
              <Box
                display={"flex"}
                alignItems={"center"}
                gap={"3px"}
                flexDirection={"column"}
              >
                <img
                  src={uploadicon}
                  alt="upload"
                  style={{ width: "28px", height: "28px" }}
                />
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#BDC1CA",
                  }}
                >
                  Browse your files here
                </Typography>
              </Box>
              <Button
                variant="contained"
                sx={{
                  marginTop: 1,
                  background: "#673C8E",
                  color: "white",
                  paddingX: "90px",
                  paddingY: "10px",
                }}
              >
                Select
              </Button>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ paddingX: "25px" }}>
        <Button
          onClick={() => {
            onClose();
            setFile(null);
          }}
          sx={{
            color: "#000",
            textTransform: "capitalize",
            fontSize: "14px",
            border: "1px solid #683C8C",
            width: "145px",
            height: "42px",
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={submitting}
          sx={{
            background: "#673C8E",
            color: "#fff",
            textTransform: "capitalize",
            fontSize: "14px",
            paddingY: "12px",
            width: "145px",
            height: "42px",
          }}
          onClick={handleSubmit}
        >
          {submitting ? "Submitting..." : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaySelectedModal;
